import { isIOSApp } from "../ios";

// Window.webkit is declared in global.d.ts
const iOSQRCodeHandler = window.webkit?.messageHandlers.scanner;

export interface QRCodeScanResult {
  success: boolean;
  qrCode: string;
}

/**
 * Scans a QR code using the native iOS scanner.
 * @returns A Promise that resolves with the scan result containing success status and QR code string
 */
export async function iosScanQRCode(): Promise<QRCodeScanResult> {
  if (!isIOSApp() || iOSQRCodeHandler === undefined) {
    throw new Error("Not running on native iOS");
  }

  return new Promise<QRCodeScanResult>((resolve) => {
    // Generate a unique callback function name (matches Window index signature)
    const callbackName =
      `scanQrCodeCallback_${Math.random().toString(36).slice(2, 9)}` as const;

    // Create the callback function dynamically
    // iOS calls this with (success: boolean, qrCode: string)
    window[callbackName] = (success: unknown, qrCode: unknown): void => {
      resolve({
        success: success === true,
        qrCode: typeof qrCode === "string" ? qrCode : "",
      });
      // Clean up: remove the callback from window after use
      delete window[callbackName];
    };

    const request = {
      method: "scanQrCode",
      callback: callbackName,
    };

    iOSQRCodeHandler.postMessage(request);
  });
}
